import { ChangeDetectionStrategy, Component, OnInit, inject, input, signal } from '@angular/core';
import { UserScopedStorageService } from '../services/user-scoped-storage.service';
import { ZagIcon } from '../icon/icon';

@Component({
  selector: 'zag-entity-detail-layout',
  imports: [ZagIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="entity-detail-layout"
      [class.entity-detail-layout--collapsible]="collapsible()"
      [class.entity-detail-layout--sidebar-collapsed]="collapsible() && collapsed()"
    >
      <aside class="entity-detail-layout__sidebar">
        @if (collapsible() && collapsed()) {
          <button type="button" class="entity-detail-layout__sidebar-expand" aria-label="Expand sidebar" (click)="toggleCollapsed()">
            <span zagIcon="chevron_right"></span>
          </button>
          <div class="entity-detail-layout__sidebar-divider"></div>
        }
        <div class="entity-detail-layout__sidebar-content">
          <ng-content select="[slot='sidebar']" />
        </div>
        <div class="entity-detail-layout__sidebar-compact">
          <ng-content select="[slot='sidebar-compact']" />
        </div>
      </aside>

      <main class="entity-detail-layout__main">
        <ng-content select="[slot='content']" />
      </main>
    </div>
  `,
  styleUrl: './entity-detail-layout.component.scss',
})
export class EntityDetailLayoutComponent implements OnInit {
  private readonly userStorage = inject(UserScopedStorageService);
  readonly collapsible = input(false);
  readonly collapseStorageKey = input<string | undefined>(undefined);
  readonly collapsed = signal(false);

  ngOnInit(): void {
    const key = this.collapseStorageKey();
    if (key && this.userStorage.get(key) === 'true') {
      this.collapsed.set(true);
    }
  }

  toggleCollapsed(): void {
    this.collapsed.update(v => !v);
    const key = this.collapseStorageKey();
    if (key) {
      this.userStorage.set(key, String(this.collapsed()));
    }
  }
}
